import React from 'react';
import styles from './Preview.module.scss';
import { CircularProgress } from '@material-ui/core';
import clsx from 'clsx';

export default function Preview(props) {
  const {
    meta: { name, percent, status }
  } = props;

  return (
    <>
      {status !== 'done' && status !== 'error_file_size' && status !== 'aborted' && (
        <div className={styles.previewWrapper}>
          <span className={clsx(status !== 'done' && styles.loading)}>{name}</span>
          <CircularProgress
            className={styles.spinner}
            variant="determinate"
            value={Math.round(percent)}
          />
        </div>
      )}
    </>
  );
}
